export default function useDocumentTitle(newTitle){
    document.title = newTitle;
}